/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Slovak
export default {
    'fabric.atlassianSwitcher.switchTo': 'Prepnúť na',
    'fabric.atlassianSwitcher.switchToTooltip': 'Prepnúť na…',
    'fabric.atlassianSwitcher.recent': 'Nedávne',
    'fabric.atlassianSwitcher.more': 'Ďalšie',
    'fabric.atlassianSwitcher.try': 'Vyskúšať',
    'fabric.atlassianSwitcher.manageList': 'Spravovať zoznam',
    'fabric.atlassianSwitcher.jiraProject': 'Projekt Jira',
    'fabric.atlassianSwitcher.confluenceSpace': 'Priestor Confluence',
    'fabric.atlassianSwitcher.people': 'Ľudia',
    'fabric.atlassianSwitcher.administration': 'Správa',
    'fabric.atlassianSwitcher.discoverMore': 'Zistite viac',
    'fabric.atlassianSwitcher.errorHeading': 'Vyskytol sa problém',
    'fabric.atlassianSwitcher.errorText': 'Tieto chyby sledujeme, ale ak obnovenie neodstráni problém, neváhajte nás kontaktovať',
    'fabric.atlassianSwitcher.errorImageAltText': 'Pracujeme na odstránení chyby.',
    'fabric.atlassianSwitcher.expand': 'Rozbaliť',
};
//# sourceMappingURL=sk.js.map